import { useEffect, useState } from 'react';

import AppButton from '../../../../commons/buttons/AppButton';
import AppContainer from '../../../../commons/containers/AppContainer';
import AppLinkButton from '../../../../commons/buttons/AppLinkButton';
import CustomCard from '../../../../commons/cards/Card';

/* eslint-disable react-hooks/exhaustive-deps */
function HPStep2({ nextStep, toBack, configToEdit }) {

    const [selectedOption, setSelectedOption] = useState(null);

    const POINTS_FOR_VALUE = 'POINTS_FOR_VALUE'
    const POINTS_FOR_SERVICE = 'POINTS_FOR_SERVICE'
    const POINTS_FOR_PERCENTAGE = 'POINTS_FOR_PERCENTAGE'


    const toNext = () => {
        nextStep(selectedOption)
    };

    useEffect(() => {
        if (configToEdit != null && Object.keys(configToEdit).length > 0) {
            setSelectedOption(configToEdit.ruleType)
        }
    }, []);


    return (
        <div className="container">
            <h6>Escolher o tipo de regra de pontuação para os serviços selecionados:</h6>
            <p>Escolha a regra de pontuação que será aplicada para os serviços selecionados:</p>

            <div className='row' onClick={() => {
                setSelectedOption(POINTS_FOR_VALUE)
            }}>
                <CustomCard backgroundColor={selectedOption === POINTS_FOR_VALUE && '#836FFF'}>
                    <p style={{ color: selectedOption === POINTS_FOR_VALUE && '#fff' }}><b>[A] Pontos por valor gasto</b></p>

                    <p style={{ color: selectedOption === POINTS_FOR_VALUE && '#fff' }}>
                        O cliente acumula pontos conforme o valor do serviço.
                        <br></br><b>Exemplo:</b> 1 ponto a cada R$10 pagos.
                    </p>

                    <p style={{ color: selectedOption === POINTS_FOR_VALUE && '#fff' }}>
                        <b>Use essa opção quando quiser incentivar gastos maiores, independente do serviço feito.</b>
                    </p>
                </CustomCard>
            </div>

            <div className='row' style={{ marginTop: '18px' }} onClick={() => {
                setSelectedOption(POINTS_FOR_SERVICE)
            }}>
                <CustomCard backgroundColor={selectedOption === POINTS_FOR_SERVICE && '#836FFF'}>
                    <p style={{ color: selectedOption === POINTS_FOR_SERVICE && '#fff' }}><b>[B] Pontos fixos por serviço</b></p>

                    <p style={{ color: selectedOption === POINTS_FOR_SERVICE && '#fff' }}>
                        Cada vez que o serviço for realizado, o cliente ganha uma quantidade fixa de pontos.
                        <br></br><b>Exemplo:</b> 5 pontos toda vez que fizer "Corte Feminino".
                    </p>

                    <p style={{ color: selectedOption === POINTS_FOR_SERVICE && '#fff' }}>
                        <b>Ideal para destacar serviços estratégicos ou com maior margem de lucro.</b>
                    </p>
                </CustomCard>
            </div>

            <div className='row' style={{ marginTop: '18px' }} onClick={() => {
                setSelectedOption(POINTS_FOR_PERCENTAGE)
            }}>
                <CustomCard backgroundColor={selectedOption === POINTS_FOR_PERCENTAGE && '#836FFF'}>
                    <p style={{ color: selectedOption === POINTS_FOR_PERCENTAGE && '#fff' }}><b>[C] Pontos proporcionais ao valor gasto</b></p>

                    <p style={{ color: selectedOption === POINTS_FOR_PERCENTAGE && '#fff' }}>
                        O cliente ganha pontos com base em uma porcentagem do valor do serviço.
                        <br></br><b>Exemplo:</b> 10% do valor vira pontos → R$100 gera 10 pontos..
                    </p>

                    <p style={{ color: selectedOption === POINTS_FOR_PERCENTAGE && '#fff' }}>
                        <b>Essa opção é útil quando o salão quer manter uma relação direta entre o preço cobrado e a recompensa oferecida — quanto mais caro o serviço, mais pontos o cliente ganha.</b>
                    </p>
                </CustomCard>
            </div>

            <p style={{ marginTop: '10px' }}>Você selecionou:</p>
            {
                selectedOption === POINTS_FOR_VALUE && '[A] Pontos por valor gasto'
            }
            {
                selectedOption === POINTS_FOR_SERVICE && '[B] Pontos fixos por serviço'
            }

            {
                selectedOption === POINTS_FOR_PERCENTAGE && '[C] Pontos proporcionais ao valor gasto'
            }
            <div style={{ marginBottom: '220px' }}></div>


            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '0rem',
                    backgroundColor: '#fff',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                }}
            >
                <AppContainer>
                    <AppLinkButton fullWidth={true} name="Próximo" width="100%" onClick={toNext} disabled={selectedOption === null} />

                    <div style={{ marginTop: '10px' }}>
                        <AppButton name="voltar" width="100%" onClick={toBack} />
                    </div>
                </AppContainer>
            </div>
        </div>
    );
}

export default HPStep2;